export default "__VITE_ASSET__C$vaFvg0__"